import style from "./style.module.scss";


function Item({data, refNo}) {
    return (
        <div className={style.root}>
            <div className={style.image} style={{ backgroundImage: 'url("/Images/newsite/welcome/welcome.jpg")' }} />

            <div className={style.descriptionCnt}>
                <div className={style.description}>
                    <div className={style.innerFrame}>
                        <div className={style.topTitle}>
                            {data?.region || ""}
                        </div>
                        <div className={style.mainTitle}>
                            {data?.location || ""}
                        </div>
                        <div className={style.line}/>
                        <div className={style.price}>
                            {monetize(data?.price)}
                        </div>
                        <div className={style.details}>
                            {`${refNo || ""} · ${data?.type || ""} · ${data.bedrooms || ""} bedrooms`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function monetize(price) {
    if (!price) return "";
    const formatter = Intl.NumberFormat({style:"decimal"});

    let value =  formatter.format(price);

    value = value.replace(new RegExp(",", "g"), " ");
    value = value + " Euro";

    return value;
}

export default Item;